import { JsonObject } from "json2typescript";
import { PortfolioanalysisAssetsInterface } from "../interfaces/portfolioanalysis-assets.interface";

@JsonObject("PortfolioanalysisAssets")
export class PortfolioanalysisAssets implements PortfolioanalysisAssetsInterface {
    AssetClass?: string;
    AssetClassId?: string;
    AssetGroup?: string;
    AssetGroupId?: string;
    AssetId?: string;
    AsseType?: string;
    AsseTypeId?: string;
    Code?: string;
    ISIN?: string;
    Issuer?: string;
    LastDate?: string;
    LastPrice?: number;
    MinimunInvestment?: number;
    Name?: string;
    Nominal?: number;
    Performance1Day?: number;
    Performance1Month?: number;
    Performance1Week?: number;
    Performance1Year?: number;
    Performance3Year?: number;
    Performance5Year?: number;
    PerformanceYear1?: number;
    PerformanceYear2?: number;
    PerformanceYear3?: number;
    PerformanceYear4?: number;
    PerformanceYear5?: number;
    PerformanceYear6?: number;
    PerformanceYtd?: number;
    PriceCotation?: string;
    ProductCode?: string;
    ProductLine?: string;
    ProductLineId?: string;
    Ratio?: number;
    Risk?: string;
    RiskLevel?: number;
    Volatility?: number;

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}
